import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PersonModel from './person';
import type ComponentReviewThreadModel from './component-review-thread';

export default class ComponentReviewCommentModel extends Model {
  @attr declare body: string;
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  @belongsTo('component-review-thread', { async: false, inverse: 'comments' })
  declare thread: ComponentReviewThreadModel;

  @belongsTo('person', { async: false, inverse: null })
  declare author: PersonModel;

  [Type] = 'component-review-comment' as const;
}
